export default __webpack_public_path__ + "static/media/8jQKh.a31e4a3e.jpg";